export default "__VITE_ASSET__Bv79mZuv__"